import type { MedicalPlan, MedicalPlanPrice } from "Utils/types";

export const calculateTotalCost = (plan: MedicalPlanPrice) => plan.employee_costs.map((c) => c.self_cost + c.family_cost).reduce((x, y) => x + y, 0);

export const calculateEstimatedCost = (plan: MedicalPlanPrice | MedicalPlan, serviceType: string) => {
  let estimatedCost = plan.estimated_costs[serviceType] || 0;
  if (serviceType == "hospitalization") {
    estimatedCost += plan.estimated_costs.hospitalization_physician || 0;
  } else if (serviceType == "surgery") {
    estimatedCost += plan.estimated_costs.surgery_staff || 0;
  } else if (serviceType == "labor_facility") {
    estimatedCost += plan.estimated_costs.labor || 0;
  }
  return estimatedCost;
};

export const calculateMaxEstimatedCost = (plan: MedicalPlanPrice | MedicalPlan, serviceType: string) => {
  const estimatedCost = calculateEstimatedCost(plan, serviceType);
  return Math.min(estimatedCost, plan.limit);
};
